<template>
  <a target="_blank" :href="eventUrl">
    <div class="f-eventCard embeddedPost-post">
      <div class="row">
        <div class="col-9">
          <div class="row">
            <div class="col-12 postAuthor text-left">
              <div class="row">
            <span class="col-4 postAuthor-name identity-name day">
              {{createdAtMoment| moment('DD')}}
            </span>
                <span class="col-8 postAuthor-name identity-name align-self-center">
                  {{createdAtMoment| moment('MMMM \'YY')}}
                </span>
              </div>
              <a class="u-linkBlend u-url customisable-highlight long-permalink">
                <p class="dt-updated post-alert" title="Time posted">
                  {{city}}
                </p>
              </a>
            </div>
          </div>
        </div>
        <div class="col-3 post-brand">
          <template>
            <a>
              <div v-if="country !== '-'" class="icon country" aria-label="Country" title="Country">
                <p id="country-code">{{country}}</p>
              </div>
              <div :class="giveClassFromType" aria-label="type" :title="type" v-b-tooltip.hover>
              </div>
            </a>
          </template>

        </div>
      </div>
      <div class="row post-body">
        <div class="col-12">
          <div class="identity-name">
            <span>{{title}}</span>
          </div>
          <p class="post-text text-justify" dir="ltr">{{description}}</p>
        </div>
      </div>

    </div>
  </a>
</template>

<script>
  export default {
    name: 'EventCard',
    data () {
      return {
        iconStyle: 'icon icon-verified',
        city: '',
        link: '',
        country: '',
        title: '',
        datePublished: '',
        description: '',
        type: ''
      }
    },
    props: {
      postContent: {
        type: Object
      }
    },
    computed: {
      eventUrl () {
        return this.link
      },
      createdAtMoment () {
        if (this.datePublished) {
          let s = this.$moment(this.datePublished)
          if (s.isValid()) {
            return s
          }
        }
        return this.$moment()
      },
      giveClassFromType () {
        return 'icon ' + this.type
      }
    },
    methods: {
      initializeFields () {
        this.city = this.postContent.city
        this.link = this.postContent.link
        this.country = this.postContent.country
        this.title = this.postContent.title
        this.datePublished = this.postContent.datePublished
        this.description = this.postContent.description
        this.type = this.postContent.type
      }
    },
    mounted () {
      this.initializeFields()
    }
  }
</script>

<style scoped>
  .f-eventCard {
    border: 1px solid #e1e8ed;
    overflow: hidden;
    cursor: pointer;
    background-color: #fff;
    border-radius: 4px;
    max-width: 500px;
    margin: 2%;
  }

  .f-eventCard:hover {
    box-shadow: 1px 1px 5px grey;
  }

  img {
    border: 0;
  }

  a {
    color: #1c2022 !important;
    text-decoration: none;
  }

  a:hover {
    text-decoration: none;
    outline: 0;
  }

  .embeddedPost-post {
    padding: 20px 20px 20px 20px;
  }

  .day {
    font-size: 3em;
  }

  .postAuthor {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -moz-box-orient: vertical;
    -moz-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
  }

  .postAuthor-name {
    overflow: hidden;
    display: inline;
  }

  .identity-name {
    font-weight: 700;
  }

  .icon {
    display: inline-block;
    height: 1.25em;
    background-size: contain;
    vertical-align: text-bottom;
    background: black no-repeat;
    color: white;
  }

  b, i {
    font-weight: 400;
    font-style: normal;
  }

  .post-brand {
    margin-left: auto;
  }

  .post-body {
    margin-top: 14px;
  }

  .post-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    margin-top: 1em;
    text-align: left;
    direction: ltr;
    cursor: pointer;
  }

  .post-text + .post-metadata {
    float: left;
    margin-top: 3.2px;
  }

  .post-alert, .post-metadata {
    font-size: 14px;
    color: #697882;
  }

  .u-linkBlend:not(:focus):not(:hover):not(:active) {
    font-weight: inherit;
    color: inherit;
    text-decoration: inherit;
  }

  .post-alert, .post-metadata {
    font-size: 12px;
    color: #697882;
  }

  .post-card {
    margin-top: 10px;
    font-size: 14px;
    width: 45%;
  }

  .post-image {
    width: 100%;
    border-radius: 5px;
  }

  .no-padding-left {
    padding-left: 0px !important;
  }

  .country {
    width: 3em;
    height: 2em;
    border-radius: 16%;
  }

  .external-event {
    width: 3em;
    height: 2em;
    border-radius: 16%;
    background-color: white;
    border: 5px solid #5b8f20;
  }

  .programme-event {
    width: 3em;
    height: 2em;
    border-radius: 16%;
    background-color: #5b8f20;
  }

  .project-event {
    width: 3em;
    height: 2em;
    border-radius: 16%;
    background: repeating-linear-gradient(
      -45deg,
      #ffffff,
      #ffffff 3px,
      #5b8f20 3px,
      #5b8f20 4.9px
    );;
  }

  #country-code {
    margin-top: 0.3em;
  }
</style>



// WEBPACK FOOTER //
// src/components/utilComponents/EventCard.vue